<template>
    <div>
      <el-form ref="searchForm" :model="searchForm" label-width="120px">
              <el-row>
            <el-col :lg="8" :offset="2">
                <el-form-item label="品牌:">
                    <el-radio-group v-model.number="searchForm.brand_id">
                        <el-radio :label="1">N牌</el-radio>
                        <el-radio :label="2">S牌</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :lg="8" >
                <el-form-item label="禮卷名稱:">
                    <el-input v-model="searchForm.name" style="width:50%;"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="2">
                <el-button type="primary" @click="fetchList" >查詢</el-button>
            </el-col>
        </el-row>
      </el-form>
      <el-row >
          <el-col :lg="22" :offset="18">
              <el-button type="primary" @click="addTabs">新增</el-button>
          </el-col>
      </el-row>
      <el-row >
          <el-col :lg="22">
                 <el-table
          :data="couponList.slice((currentPage-1)*pagesize,currentPage*pagesize)"
          empty-text="暫無數據"
          style="width: 100%"
          :header-cell-style="tableHeaderColor">
          <el-table-column label="使用期限" prop="on_sale_start, on_sale_end">
              <template slot-scope="scope" >
                {{scope.row.on_sale_start}} - {{scope.row.on_sale_end}}
              </template>
               </el-table-column>
          <el-table-column label="品牌" prop="brand_id">
              <template slot-scope="scope">
                  {{scope.row.brand_id == 1 ? 'N牌':'S牌'}}
              </template>
               </el-table-column>
          <el-table-column label="名稱" prop="name"> </el-table-column>
          <el-table-column label="詳細"> 
            <template slot-scope="scope">
                  <el-button type="info"  icon="el-icon-more" @click="detailTabs( scope.row)"  circle ></el-button>
            </template>
          </el-table-column>
        
          <el-table-column label="作廢">
                 <template slot-scope="scope">
                    <el-switch v-model="scope.row.status" active-color="#13ce66" 
                    inactive-color="#ff4949" inactive-text="作廢" active-text="啟用" 
                    @change="updateStatus(scope.$index, scope.row)"></el-switch>
             </template> </el-table-column>
      </el-table>
        <el-pagination
        background
        layout="prev, pager, next"
        :total="total1"
        @current-change="current_change"
        >
      </el-pagination>
          </el-col>
      </el-row>
        
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'Search',
        data() {
            return {
                couponList: [],
                searchForm: {
                    brand_id: null,
                    name: ''
                },
                couponKey: '',
                   total1: 0,
                 currentPage:1,
                pagesize: 10,
            }
        },
        computed: mapGetters(["getCouponList", "getCouponError", "getCouponMsg"]),
        methods: {
            ...mapActions(["fetchCouponList", "updateCouponStatus"]),
           async fetchList(){
                const data = {brand_id: this.searchForm.brand_id, name: this.searchForm.name}
                await this.$store.dispatch('fetchCouponList', data)
                            this.couponList = this.getCouponList
                            this.total1 = this.couponList.length
                            
            },
            async updateStatus(index, row){
                const data = {_key: row._key, status: row.status}
                await this.$store.dispatch('updateCouponStatus', data)
                    if (this.getCouponError) {
                        this.$notify({
                            title: '失敗',
                            message: this.getCouponMsg,
                            type: 'error',
                            duration: '4500',
                            position: 'top-right'
                        });
                        } else {
                            this.$notify({
                                title: '成功',
                                message: '改變狀態成功',
                                type: 'success',
                                duration: '4500',
                                position: 'top-right'
                            });
                            
                        }
            },
            addTabs(){
                this.$emit('addTabs')
            },
            detailTabs( row){
                
                this.couponKey = row._key
                this.$emit('detailTabs', this.couponKey)
            },
              tableHeaderColor({row, column, rowIndex, columnIndex}){
                if(rowIndex === 0){
                    return `background-color: gray;color: #000;`
                }
            },
            current_change: function (currentPage) {
                this.currentPage = currentPage;
            },
        },
    }
</script>

<style lang="scss" scoped>
    
</style>